import { Tag, TagPropsStrict } from '@servicetitan/design-system';
import { FC } from 'react';
import { JobListItemStatus } from '../../../api/portal-dashboard.api';

const statuses: Record<JobListItemStatus, [TagPropsStrict['color'], boolean, string]> = {
    [JobListItemStatus.Scheduled]: ['info', true, 'Scheduled'],
    [JobListItemStatus.InProgress]: ['success', false, 'In Progress'],
    [JobListItemStatus.OnHold]: ['warning', true, 'Hold'],
    [JobListItemStatus.Canceled]: ['critical', true, 'Canceled'],
    [JobListItemStatus.Completed]: ['success', true, 'Completed'],
};

export const JobStatusTag: FC<{ status: JobListItemStatus }> = ({ status }) => {
    const data = statuses[status];
    return data ? (
        <Tag color={data[0]} subtle={data[1]}>
            {data[2]}
        </Tag>
    ) : null;
};
